export default function CTA() {
  return <></>;
}
